import moment from 'moment';
import configSelectors from '../../infrastructure/config/';

const getStaffRequestHeader = (storeState) => {
  const bankId = configSelectors.bankId(storeState);
  const staffBranchSortCode = configSelectors.staffBranchSortCode(storeState);
  const customerNumber = configSelectors.customerNumber(storeState);
  return {
    'x-bpi-customer-id': customerNumber,
    'x-bpi-trust-created-dt': moment().format('YYYY-MM-DDTHH:mm:ss'),
    'x-bpi-trust-level': 40,
    'x-bpi-customer-bank-id': bankId,
    'x-bpi-branch-sort-code': staffBranchSortCode,
  };
};
export const getRequestHeader = (storeState) => {
  const sourceType = configSelectors.sourceType(storeState);
  const clientContext = configSelectors.clientContext(storeState);
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-bpi-client-context': clientContext,
    ...(sourceType === 'staff' ? getStaffRequestHeader(storeState) : {}),
  };
};
